export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-random/src/defaultSource.js
// module id = h2i+
// module chunks = 0